/*
 * @Author:
 * @Date: 2021-03-25 14:01:37
 * @Description: 登录、获取用户信息、登出等公用接口
 */
import request from "./http/request";
const login = data => {
  return request({
    url: "/api/Login/auth",
    method: "post",
    data,
  });
};
const bindLogin = data => {
  return request({
    url: "/api/User/bind",
    method: "post",
    data,
  });
};
const wxlogin = data => {
  console.log("request api wxlogining...", data);
  return request({
    url: "/api/Login/auth",
    method: "post",
    data
  });

};
const getCode = token => {
  return request({
    url: "/api/Login/code",
    method: "get",
  });
};
const getInfo = token => {
  return request({
    url: "/api/User/userinfo",
    method: "get",
    params: { "scope": "phone" },
  });
};
const getMenu = id => {
  return request({
    url: "/system/menu/findMenuByUserIdAndOrgSeqNumAndRoleId/" + id,
    method: "get"
  });
};
const logOut = token => {
  return request({
    url: "/api/Login/logout",
    method: "get",
    params: { token }
  });
};

export { getCode, login, getInfo, getMenu, logOut, wxlogin, bindLogin };
